<div class="flexbox-container flex-vertical-centered">
  <div *ngIf="isNA" class="percentage percentage-na">N/A</div>
  <div *ngIf="!isNA && percentage > 0 && percentage < 1" class="percentage">{{ percentage | number:'1.2-2' }} %</div>
  <div *ngIf="!isNA && (percentage >= 1 || percentage === 0)" class="percentage">{{ percentage | number:'1.0-0' }} %</div>

  <div class="progress">
    <div *ngIf="!isNA" class="progress-bar" [style.width]="percentage + '%'" [ngClass]="'bg-' + background"></div>
  </div>
</div>
